import React, { Component } from 'react'
import { ItemData } from '../apis/item.api'
import ContentAside from '../components/ContentAside'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ItemCard, { ItemCardData } from '../components/ItemCard'
import BarePalletCreateForm from '../partials/BarePalletCreateForm'

interface Props {}

interface State {
  item: ItemCardData | null
}

export default class BarePalletCreate extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      item: null
    }
    this.handleItemSelect = this.handleItemSelect.bind(this)
    this.handleCreate = this.handleCreate.bind(this)
  }

  get itemCard () {
    const { item } = this.state
    return item &&
      <ItemCard
        code={item.code}
        description={item.description}
        cpp={item.cpp}
        qpc={item.qpc} />
  }

  handleItemSelect (item: ItemData | null) {
    this.setState({ item })
  }

  handleCreate () {
    this.setState({ item: null })
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <BarePalletCreateForm
            onItemSelect={this.handleItemSelect}
            onCreate={this.handleCreate} />
        </ContentMain>
        <ContentAside layout="oneThird">
          {this.itemCard}
        </ContentAside>
      </ContentLayout>
    )
  }
}
